<template>
  <v-select
    :value="value"
    :options="options"
    label="text"
    :reduce="(item) => item.value"
    :disabled="disabled"
    :required="required"
    :placeholder="placeholder"
    :loading="loading"
    @input="onInput"
  ></v-select>
</template>

<script>
import 'vue-select/dist/vue-select.css'
export default {
  name: 'HelperJenjangSelect',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    public: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '-- Pilih Jenjang Pendidikan --',
    },
  },
  data() {
    return {
      options: [],
      loading: false,
    }
  },
  watch: {
    value() {
      this.emitChange()
    },
  },
  mounted() {
    this.loadOptions()
  },
  methods: {
    async loadOptions() {
      this.loading = true
      try {
        const url = this.public ? '/api/jenjang-pendidikan' : '/api/admin/options/jenjang-pendidikan'
        const res = await this.$axios.get(url)
        this.options = res.data.data || []
        this.emitChange()
      } catch (e) {
        this.options = []
      } finally {
        this.loading = false
      }
    },
    findOption(id) {
      return this.options.find((o) => o.value === id) || null
    },
    emitChange() {
      this.$emit('change', this.findOption(this.value))
    },
    onInput(id) {
      this.$emit('input', id)
    },
  },
}
</script>
